/**
 * CMS Components
 *
 * Reusable components for building CMS pages with consistent
 * SCW brand styling. These components match the production site
 * design patterns.
 *
 * Usage:
 * import { PageHero, SectionHeader, FeatureBlock, RelatedBox, Breadcrumbs, ContentSection } from '@/components/cms';
 */

export { PageHero } from './PageHero';
export { CmsPageBanner } from './CmsPageBanner';
export type { CmsPageBannerProps, CmsPageBannerCrumb, CmsPageBannerCta } from './CmsPageBanner';
export { SectionHeader } from './SectionHeader';
export { FeatureBlock } from './FeatureBlock';
export { RelatedBox } from './RelatedBox';
export { Breadcrumbs } from './Breadcrumbs';
export { ContentSection } from './ContentSection';
export { CmsContainer } from './CmsContainer';
export { CmsGrid } from './CmsGrid';
export { LeanOnExperts } from './LeanOnExperts';
export type { LeanOnExpertsConfig, LeanOnExpertsProps } from './LeanOnExperts';
export { CmsVideoEmbed } from './CmsVideoEmbed';
export type { CmsVideoEmbedProps, CmsVideoEmbedIframeAttrs } from './CmsVideoEmbed';
export { HotboxCtaStrip } from './HotboxCtaStrip';
export type {
  HotboxCtaStripProps,
  HotboxCard,
  HotboxCtaStripConfig,
  HotboxVariant,
} from './HotboxCtaStrip';
export { ExpertCtaStrip } from './ExpertCtaStrip';
export type {
  ExpertCtaStripProps,
  ExpertCtaStripBirdeyeConfig,
  ExpertCtaStripCaption,
  ExpertCtaStripConfig,
  ExpertCtaStripPhone,
} from './ExpertCtaStrip';
